module.exports = __webpack_public_path__ + "static/media/icon_up.8d2d8c0b.svg";